import { Alert, AlertTitle, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

export const NoPermissionAlert = ({ missing = '' }: { missing?: string }) => {
  const { t } = useTranslation();
  return (
    <Alert severity='warning' sx={{ padding: 5 }}>
      <AlertTitle>{t('shared:noPermission')}</AlertTitle>
      {missing && (
        <Typography variant='labelSmall'>
          {t('shared:missingPermissionIs')}: &nbsp;
          <kbd>{missing}</kbd>
        </Typography>
      )}
    </Alert>
  );
};
